import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { QUERY_KEYS } from '@/lib/queryKeys'

import { getAppConfig } from '../configService'

export const useAppConfig = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.APP_CONFIG],
    queryFn: getAppConfig,
    staleTime: 5 * 60 * 1000,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    retry: (failureCount, error) => {
      if (error instanceof AxiosError && error.response?.status === 503) {
        return false
      }
      return failureCount < 2
    },
  })
}
